{
  "process.oneshot.label": "OneShot",
  "process.oneshot.badge": "OneShot",
  "process.oneshot.tooltip.title": "Processo OneShot",
  "process.oneshot.tooltip.description": "Processos oneshot consideram apenas horário de fim para cálculo de status.",
  "process.oneshot.modal.title": "Confirmar alteração",
  "process.oneshot.modal.description": "Alterar o modo OneShot impactará o cálculo de status deste processo. Deseja continuar?",
  "process.standard.badge": "Padrão"
}
